import { FC, ReactNode } from "react";

interface GenericCardInfosProps {
  children: ReactNode,
  aside?: ReactNode,
  headerAction?: ReactNode,
  footerAction?: ReactNode,
  className?: string
}

export const GenericCardInfos: FC<GenericCardInfosProps> = ({
  children,
  aside,
  headerAction,
  footerAction,
  className
}) => {
  return (
    <div className={`bg-white border rounded-xl p-8 relative ${className}`}>
      {/* Action en haut à droite (croix de suppression) */}
      {headerAction && (
        <div className="absolute top-4 right-4">
          {headerAction}
        </div>
      )}
      {/* Legacy aside - bouton d'action en haut à droite */}
      {aside && !headerAction && (
        <div className="absolute top-4 right-4">
          {aside}
        </div>
      )}
      {/* Contenu principal */}
      <div className="space-y-2">
        {children}
      </div>
      {/* Action en bas à droite (bouton modifier) */}
      {footerAction && (
        <div className="absolute bottom-4 right-4">
          {footerAction}
        </div>
      )}
    </div>
  );
};
